import { useUpdateDeviceInformationMutation } from "../../store/storageRoles/devicesSharedApi";

const useUpdateDeviceData = () => {
  const [
    updateDevice,
    {
      data: updateDeviceData,
      isLoading: updateDeviceIsLoading,
      isSuccess: updateDeviceIsSuccess,
      isError: updateDeviceIsError,
      error: updateDeviceError,
    },
  ] = useUpdateDeviceInformationMutation();

  return {
    updateDevice,
    updateDeviceIsLoading,
    updateDeviceIsSuccess,
    updateDeviceIsError,
    updateDeviceError,
    updateDeviceData,
  };
};

export default useUpdateDeviceData;
